import { CheckCircle2, Clock, RotateCcw, Upload, Lock, FileText } from "lucide-react";

const META = {
  approved: { icon: CheckCircle2, dot: "bg-emerald-500", ring: "border-emerald-500", text: "text-emerald-700", label: "Approved" },
  in_review: { icon: Clock, dot: "bg-amber-500", ring: "border-amber-500", text: "text-amber-700", label: "In review" },
  revise: { icon: RotateCcw, dot: "bg-orange-500", ring: "border-orange-500", text: "text-orange-700", label: "Revise & resubmit" },
  available: { icon: Upload, dot: "brand-bg", ring: "brand-border", text: "brand-text", label: "Ready to submit" },
  locked: { icon: Lock, dot: "bg-slate-300", ring: "border-slate-300", text: "text-slate-400", label: "Locked" },
};

export default function ThesisProgress({ progression }) {
  if (!progression) return null;
  const conceptMeta = progression.concept_approved ? META.approved : META.in_review;
  const CIcon = progression.concept_approved ? CheckCircle2 : Clock;

  const nodes = [
    { name: "Concept Paper", status: progression.concept_approved ? "approved" : "in_review", meta: conceptMeta, Icon: CIcon, concept: true },
    ...progression.stages.map((s) => ({ name: s.name, status: s.status, meta: META[s.status] || META.locked, Icon: (META[s.status] || META.locked).icon })),
  ];

  return (
    <div className="space-y-0" data-testid="thesis-progress">
      {nodes.map((n, i) => {
        const isLast = i === nodes.length - 1;
        return (
          <div key={n.name} className="flex gap-3">
            <div className="flex flex-col items-center">
              <div className={`h-8 w-8 rounded-full border-2 flex items-center justify-center bg-white ${n.meta.ring}`}>
                <n.Icon className={`h-4 w-4 ${n.meta.text}`} />
              </div>
              {!isLast && <div className="w-px flex-1 min-h-[18px] bg-border my-1" />}
            </div>
            <div className={`pb-4 ${isLast ? "" : ""}`}>
              <p className="text-sm font-medium text-foreground flex items-center gap-2">
                {n.concept && <FileText className="h-3.5 w-3.5 text-muted-foreground" />}
                {n.name}
              </p>
              <p className={`text-xs ${n.meta.text}`}>{n.meta.label}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
